import { Add } from "@mui/icons-material"
import { Grid, Button } from "@mui/material"
import { Control, UseFormSetValue, useFieldArray } from "react-hook-form"
import { EducationFields } from "../../../../../../Shared Components/EducationFields"
import { Education } from "../../../../../../Types/Resume";
import { ViewEducation } from "../../View/ViewEducation";
import { EducationType, ExperienceType } from "../../../../../../Schemas/ResumeSchemas";
import { useState } from "react";
import { TalentProfileType } from "../../../../../../Schemas/TalentSchemas";
import { ModifyExperienceModal } from "./ModifyExperienceModal";
import { ViewExperience } from "../../View/ViewExperience";

interface IProps {
    experience: ExperienceType[];
    updateExperience?: UseFormSetValue<TalentProfileType>;
    readOnly?: boolean;
}

export const ExperienceSection = ({ experience, updateExperience, readOnly = false }:IProps) => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const [ open, setOpen ] = useState(false);
    /* ******************** Functions ******************** */
    const handleChange = (data: ExperienceType) => {
        const updatedExperience = Array.from(experience)
        updatedExperience.push(data);
        updateExperience!('Experience', updatedExperience, { shouldDirty: true});
        setOpen(false);
    }
    const handleEdit = (edu: ExperienceType, idx: number) => {
         const updatedExperience = Array.from(experience);
         updatedExperience.splice(idx, 1, edu);
         updateExperience!('Experience', updatedExperience);
    }
    const handleDelete = (idx: number) => {
        const updatedExperience = Array.from(experience);
        updatedExperience.splice(idx, 1);
        updateExperience!('Experience', updatedExperience);
    }
    const handleOpen = () => {
        setOpen(true);
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            {
                experience?.map((edu, index) => (
                    <ViewExperience 
                        key={edu.title + index}
                        readOnly={readOnly}
                        {...{index, handleEdit, handleDelete, ...edu}}
                    />
                ))
            }
            {!readOnly && 
            <Grid item display={"flex"} flexDirection={"row"}>
                    <Button color='primary'  onClick={handleOpen} >
                        <Add fontSize='small' sx={{marginRight: 0.5}}/>Add work experience
                    </Button> 
            </Grid>}
            <ModifyExperienceModal
                {...{
                    open,
                    setOpen,
                    handleChange,
                    type: 'Add'
                }}
            />
        </>
    )
}